export default "__VITE_ASSET__CJRpSqBN__"